import store from "../store/store";
import { setLoader } from "store/uiSlice";
import { toastMessage } from "./mixins";
import { logout } from "store/userSlice";

export default function handleError(error: any) {
  let message =
    error?.response?.data || error?.message || "Unexpected Error Occured.";

  if (typeof error === "string") {
    message = error;
  } else if (error?.response?.status === 403) {
    message = "Bu alana erişmek için gerekli yetkiye sahip değilsiniz!";
  } else if (error?.response?.status === 401) {
    message = "Oturumunuz zaman aşımına uğradı. Lütfen tekrar giriş yapın.";
    store.dispatch(logout());
  } else if (typeof message == "object" && message.exception) {
    message = message.exception;
  } else if (message.validation_errors) {
    let validationMessage = "";
    for (const key in message.validation_errors) {
      const value = message.validation_errors[key];
      validationMessage += "⦿ " + value[0] + "\n\r";
    }
    message = validationMessage;
  } else if (message.data) {
    message = message.data;
  }else if(message.message){
    message = message.message;
  }

  store.dispatch(setLoader(false));
  toastMessage(message || "Beklenmedik bir hata oluştu.", "error", message);
}
